import { Route, Routes } from 'react-router-dom'
//import { RegistrationBeta } from './components/RegistrationBeta'
import { Registration } from './components/Registration' //the original registration page
import MultiStepSignup from './components/MultiStepSignup'
import SignupFlowDemo from './components/SignupFlowDemo'
//import { Regloader } from './components/Regloader'
import { ForgotPassword } from './components/ForgotPassword'
import { ResetPassword } from './components/ResetPassword'
import { Login } from './components/Login'
import { AuthLayout } from './AuthLayout'
import { Otp } from './components/Otp'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      {/* Email verification signup is now the default registration experience */}
      <Route path='registration' element={<MultiStepSignup />} />
      <Route path='signup' element={<MultiStepSignup />} />
      {/* Legacy registration available for fallback */}
      <Route path='legacy-registration' element={<Registration />} />
      <Route path='demo' element={<SignupFlowDemo />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='reset-password' element={<ResetPassword />} />
      {/* <Route path='otp' element={<Otp />} /> */}
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export { AuthPage }
